import { Component, ViewChild, TemplateRef } from '@angular/core';
import { CustomTooltipComponent } from '../../../shared-components/custom-tooltip/custom-tooltip.component';

@Component({
	selector: 'app-custom-tooltip-showcase',
	templateUrl: './custom-tooltip-showcase.component.html',
	styleUrls: ['./custom-tooltip-showcase.component.scss'],
	standalone: false,
})
export class CustomTooltipShowcaseComponent {
	@ViewChild('manualTooltip') manualTooltip!: CustomTooltipComponent;

	// HTML content examples
	htmlContent = '<strong>Bold text</strong> and <em>italic text</em> with <span style="color: #007bff;">colored</span> content.';

	richContent = `
		<div style="text-align: center;">
			<h6 style="margin: 0 0 8px 0; color: #007bff;">Rich Content</h6>
			<p style="margin: 0; font-size: 12px;">This tooltip contains<br>multiple lines<br>of formatted content</p>
		</div>
	`;

	listContent = `
		<ul style="margin: 0; padding-left: 20px;">
			<li>First item</li>
			<li>Second item</li>
			<li>Third item</li>
		</ul>
	`;

	// Interactive counters
	likeCount = 42;
	shareCount = 18;
	progressValue = 65;

	// Interactive methods
	onLike(): void {
		this.likeCount++;
		console.log('Like clicked, total:', this.likeCount);
	}

	onShare(): void {
		this.shareCount++;
		console.log('Share clicked, total:', this.shareCount);
	}

	updateProgress(): void {
		this.progressValue = Math.floor(Math.random() * 100);
		console.log('Progress updated to:', this.progressValue);
	}

	// Template references for complex content
	@ViewChild('customTemplate') customTemplate!: TemplateRef<any>;
	@ViewChild('actionTemplate') actionTemplate!: TemplateRef<any>;
	@ViewChild('formTemplate') formTemplate!: TemplateRef<any>;
	@ViewChild('interactiveTemplate') interactiveTemplate!: TemplateRef<any>;
	@ViewChild('progressTemplate') progressTemplate!: TemplateRef<any>;
	@ViewChild('chartTemplate') chartTemplate!: TemplateRef<any>;
}
